import en from "./locales/en";
import ar from "./locales/ar";
import ku from "./locales/ku";

const locales = { en, ar, ku };

const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, part) => acc?.[part], obj);

export const getTranslation = (language, key) => {
  const locale = locales[language] || locales.en;
  const value = getNestedValue(locale, key);
  return value ?? getNestedValue(locales.en, key) ?? key;
};

export default locales;
